import Vue from 'vue';
import Component from 'vue-class-component';
import EdCalendar from '@/core/components/ed-calendar/ed-calendar.vue';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { PRIVATE_ROUTES } from '../private.routes';

@Component({
  components: {
    EdCalendar,
    EdPortalTools: () => import(/* EdMainTools */'./components/ed-portal-tools/ed-portal-tools.component.vue')
  }
})
export default class PortalViewComponent extends Vue {

  get hasHeader(): boolean {
    return this.$store.state.AppStore.header.visible;
  }

  get isExpandCalendar(): boolean {
    return this.$store.state.AppStore.expandCalendar;
  }

  setHtmlScroll(value = 'auto') {
    const HTML = document.querySelector('html');
    HTML.style.overflow = value;
  }

  mounted() {
    this.setHtmlScroll('hidden');
    ScreenMirroringService.emitScreenMirroringEvent(
      this,
      {
        target: SCREEN_MIRRORING_EVENTS.GO_TO_PAGE,
        name: PRIVATE_ROUTES.PORTAL.NAME,
      }
    );
  }

  beforeDestroy() {
    this.setHtmlScroll();
  }

}
